export default __webpack_public_path__ + "static/test-rail-674332828de840357b6f42bd46e65a20.svg";